// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { ICombineHsaSearchResponse } from './ICombineHsaSearchResponse';
import {
    ICombineHsaSearchResponseFromJSON,
    ICombineHsaSearchResponseFromJSONTyped,
    ICombineHsaSearchResponseToJSON,
    ICombineHsaSearchResponseToJSONTyped,
} from './ICombineHsaSearchResponse';

/**
 * 
 * @export
 * @interface ICustomPageCombineHsaSearchResponse
 */
export interface ICustomPageCombineHsaSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageCombineHsaSearchResponse
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageCombineHsaSearchResponse
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageCombineHsaSearchResponse
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageCombineHsaSearchResponse
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageCombineHsaSearchResponse
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<ICombineHsaSearchResponse>}
     * @memberof ICustomPageCombineHsaSearchResponse
     */
    content?: Array<ICombineHsaSearchResponse>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPageCombineHsaSearchResponse
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageCombineHsaSearchResponse
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageCombineHsaSearchResponse
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageCombineHsaSearchResponse
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPageCombineHsaSearchResponse interface.
 */
export function instanceOfICustomPageCombineHsaSearchResponse(value: object): value is ICustomPageCombineHsaSearchResponse {
    return true;
}

export function ICustomPageCombineHsaSearchResponseFromJSON(json: any): ICustomPageCombineHsaSearchResponse {
    return ICustomPageCombineHsaSearchResponseFromJSONTyped(json, false);
}

export function ICustomPageCombineHsaSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageCombineHsaSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ICombineHsaSearchResponseFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPageCombineHsaSearchResponseToJSON(json: any): ICustomPageCombineHsaSearchResponse {
    return ICustomPageCombineHsaSearchResponseToJSONTyped(json, false);
}

export function ICustomPageCombineHsaSearchResponseToJSONTyped(value?: ICustomPageCombineHsaSearchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(ICombineHsaSearchResponseToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

